import { render } from "./WebView.vue?vue&type=template&id=4cf56925&scoped=true"
import script from "./WebView.vue?vue&type=script&lang=js"
export * from "./WebView.vue?vue&type=script&lang=js"

import "./WebView.vue?vue&type=style&index=0&id=4cf56925&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf56925"]])

export default __exports__